import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo } from './';
import * as Dati from '../Dati';
import * as Glob from '../Globale';

interface IRubricaProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON rubrica
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup?: any) => any;
}

export class Rubrica extends BasePureComponent<IRubricaProps> {
    private _Dati: Dati.CDatoRubrica[] = [];
    private _Tipologia: Dati.TDictTipo = {};

    protected OnAggiorna(c: string, i: number, v: any): any {
        const {OnChange, OnChangeAppendice, Name} = this.props;

        switch (c) {
            case "ID_Tipologia":
                this._Dati[i].ID_Tipologia = Number(v);
                break;
            case "TipoRecapito":
                this._Dati[i].TipoRecapito = v;
                break;
            case "Valore":
                this._Dati[i].Valore = v;
                break;
        }
        OnChange(Name, JSON.stringify(this._Dati));
        if(OnChangeAppendice) {
            const elementGroup = [
                {ValoreAppendice: this._Dati[i].Valore},
                {ValoreAppendice: this._Dati[i].TipoRecapito == 'PR'? Trad.Trad("Professionale") : Trad.Trad("Personale")},
                {ValoreAppendice: Trad.Trad(this._Tipologia[this._Dati[i].ID_Tipologia].Valore)}
            ];
   
            OnChangeAppendice(`${Name}[${i.toString()}]`, JSON.stringify(this._Dati[i]), Name, 0, elementGroup);
        }
    }

    private OnAggiungi() {
        let dato: Dati.CDatoRubrica = new Dati.CDatoRubrica();
        this._Dati.push(dato);
        this.props.OnChange(this.props.Name, JSON.stringify(this._Dati));
    }

    private OnRimuovi(indice: number) {
        const {OnChange, OnChangeAppendice, Name} = this.props;

        this._Dati.splice(indice, 1);
        OnChange(Name, JSON.stringify(this._Dati));
        if(OnChangeAppendice) {
            OnChangeAppendice(`${Name}[${indice.toString()}]`, {}, Name, 0);
        }
    }

    public constructor(props: any) {
        super(props);
        this.Inizializza(this.props);
    }

    private Inizializza(props: IRubricaProps) {
        this.PopolaDati(props.Value);
    }

    private PopolaTipi() {
        this._Tipologia = {};
        this._Tipologia["1"] = new Dati.CTipo("1", "Telefono");
        this._Tipologia["2"] = new Dati.CTipo("2", "Cellulare");
        this._Tipologia["3"] = new Dati.CTipo("3", "Fax");
        this._Tipologia["4"] = new Dati.CTipo("4", "Email");
        this._Tipologia["5"] = new Dati.CTipo("5", "PEC");
    }

    private TipoIcona(tipo: number): string {
        switch (tipo) {
            case 1:
                return "la-phone";
            case 2:
                return "la-mobile";
            case 3:
                return "la-fax";
            case 4:
                return "la-envelope";
            case 5:
                return "la-gavel";
        }
        return "la-edit";
    }

    private PopolaDati(valore: string | Dati.CDatoRubrica[]) {
        this.PopolaTipi();
        let DatiApp: Dati.CDatoRubrica[] = [];
        if (valore != undefined && valore != "") {
            //let DatiApp: Dati.CDatoRubrica[];
            if (typeof (valore) == "string") {
                DatiApp = JSON.parse(valore);
            } else {
                DatiApp = valore;
            }
        }
        this._Dati = DatiApp;
    }

    public render() {
        this.Inizializza(this.props);

        let valori: any[] = [];
        for (let i: number = 0; i < this._Dati.length; i++) {
            valori.push(<div className="form-group special-group kt-form login-form__group row" key={i + 1}>
                <div className="col-lg-3">
                    <Tipo Dati={this._Tipologia} ID_ChiaveString={this._Dati[i].ID_Tipologia.toString()} Campo={"Tipo_" + i} OnAggiorna={(e, v) => this.OnAggiorna("ID_Tipologia", i, v)} />
                </div>
                <div className="col-lg-4">
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" value={this._Dati[i].Valore} className="form-control" onChange={(e) => { this.OnAggiorna("Valore", i, e.currentTarget.value) }} placeholder={Trad.Trad("Recapito")} />
                        <span className="kt-input-icon__icon kt-input-icon__icon--right">
                            <span>
                                <i className={"la " + this.TipoIcona(this._Dati[i].ID_Tipologia)}></i>
                            </span>
                        </span>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="kt-radio-inline inlinea">
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input value="PE" type="radio" checked={this._Dati[i].TipoRecapito == "PE"} onChange={(e) => { this.OnAggiorna("TipoRecapito", i, e.currentTarget.value) }} />{Trad.Trad("Personale")}<span></span></label>
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input value="PR" type="radio" checked={this._Dati[i].TipoRecapito == "PR"} onChange={(e) => { this.OnAggiorna("TipoRecapito", i, e.currentTarget.value) }} />{Trad.Trad("Professionale")}<span></span></label>
                    </div>
                </div>
                <div className="col-lg-1 remove-square-button">
                    <button type="button" className="btn btn-danger square-button-with-icon" onClick={() => this.OnRimuovi(i)} title={Trad.Trad("Elimina")}> <i className="fa fa-minus"></i></button>
                </div>
            </div>);
        }
        return <div className="kt-portlet bg-fill-success kt-portlet--head-solid-bg kt-portlet--bordered" key={0}>
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-phone"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Recapiti")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <li className="kt-portlet__nav-item">
                            <a href="#" onClick={(e) => { e.preventDefault(); this.OnAggiungi() }} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo recapito")}>
                                <i className="fa fa-plus"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-portlet__body">
                {valori}
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Rubrica.tsx